import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMongodbComponent } from './simple-icons-mongodb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMongodbComponent ],
    exports:      [ SimpleIconsMongodbComponent ],
    bootstrap:    []
})
export class SimpleIconsMongodbModule {}
